import { useDrawer } from "../../../hooks";
import { AuthContext } from "../../../context";
import { useContext, useState } from "react";
import { Drawer, SimpleToolbar, Loader, Toast } from "../../../components";
import { Grid, Container, makeStyles, Paper } from "@material-ui/core";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { FormRepresentative } from "../../../components/form-representative";
import { laboratoryServices } from "../../../services";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

export default function UpdateRepresentativeScreen() {
  const { authState } = useContext(AuthContext);
  const { isOpen, setIsOpen } = useDrawer();
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const classes = useStyles();
  const history = useHistory();
  const { labRepresentativeId } = useParams();

  const updateRepresentative = async (data) => {
    // console.log("final data", data);
    try {
      setLoading(true);

      const { status, response } =
        await laboratoryServices.updateLabRepresentative({
          labRepresentativeInfo: {
            ...data,
            laboratoryId: authState.user.laboratory._id,
            _id: labRepresentativeId
          },
          token: authState.token,
        });
      setToast(true);
      setToastMessage(
        status === 200
          ? "Representante actualizado exitosamente"
          : response.message
      );
      if (status === 200) {
        setTimeout(() => {
          history.replace("/zones/representative");
        }, 700);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.root}>
        {loading && <Loader loading={true} />}
        <Toast
          open={toast}
          message={toastMessage}
          close={() => setToast(false)}
        />
        <Grid item xs={12} className={classes.content}>
          <Container maxWidth={false}>
            <SimpleToolbar
              hideExport={authState.user.laboratory}
              isOpen={isOpen}
              setIsOpen={(value) => setIsOpen(value)}
              noSearchBar
            />
          </Container>

          <Container
            maxWidth={"md"}
            component={"main"}
            className={classes.container_main}
          >
            <Paper className={classes.custom_paper}>
              <FormRepresentative onHandleSubmit={updateRepresentative}  isEdit={true}/>
            </Paper>
          </Container>
        </Grid>
      </Grid>
    </>
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    flex: 1,
    minHeight: "100vh",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  container_main: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(2),
    height: "100%",
  },
  custom_paper: {
    padding: theme.spacing(3),
    [theme.breakpoints.only("xs")]: {
      padding: theme.spacing(1),
    },
  },
}));
